// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
    background-color: #f8f9fa;
    font-family: Arial, sans-serif;
  }
  
  .card {
    margin-top: 50px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .card-title {
    margin-bottom: 10px;
    padding: 5px;
    color: grey;
    font-weight: bold;
  }
  
  .input-group-text {
    background-color: #e9ecef;
    border-left: 0;
    cursor: pointer;
  }
  
  .form-control {
    border-right: 0;
  }
  
  .form-control:focus {
    box-shadow: none;
  }
  
  .btn-primary {
    transition: background-color 0.3s ease;
    float: inline-end;
    margin-top: 20px;
  } */

  body {
    background-color: #f8f9fa;
    font-family: Arial, sans-serif;
  }
  
  .card {
    margin-top: 50px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .card-title {
    margin-bottom: 10px;
    padding: 5px;
    color: grey;
    font-weight: bold;
  }
  
  .input-group-text {
    background-color: #e9ecef;
    border-left: 0;
    cursor: pointer;
    border: none;
    padding: 0;
  }
  
  .form-control {
    border-right: 0;
  }
  
  .form-control:focus {
    box-shadow: none;
  }
  
  .btn-primary {
    transition: background-color 0.3s ease;
    float: inline-end;
    margin-top: 20px;
  }
  
  .input-group {
    position: relative;
  }
  
  .login-form-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
  }
  
  .input-group input {
    padding-right: 30px;
  }

  .dabur-logo {
    /* background-color: rgba(255, 255, 255, 0.334); */
    border-radius: 50%;
    height: 100px;
    width: 100px;
    padding: 20px;
  }
  
  .recaptcha-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

.g-recaptcha {
    width: 100% !important;
}

.g-recaptcha div {
    width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/LoginForm/LoginForm.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAoCK;;EAEH;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["/* body {\r\n    background-color: #f8f9fa;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  .card {\r\n    margin-top: 50px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .card-title {\r\n    margin-bottom: 10px;\r\n    padding: 5px;\r\n    color: grey;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .input-group-text {\r\n    background-color: #e9ecef;\r\n    border-left: 0;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .form-control {\r\n    border-right: 0;\r\n  }\r\n  \r\n  .form-control:focus {\r\n    box-shadow: none;\r\n  }\r\n  \r\n  .btn-primary {\r\n    transition: background-color 0.3s ease;\r\n    float: inline-end;\r\n    margin-top: 20px;\r\n  } */\r\n\r\n  body {\r\n    background-color: #f8f9fa;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  .card {\r\n    margin-top: 50px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .card-title {\r\n    margin-bottom: 10px;\r\n    padding: 5px;\r\n    color: grey;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .input-group-text {\r\n    background-color: #e9ecef;\r\n    border-left: 0;\r\n    cursor: pointer;\r\n    border: none;\r\n    padding: 0;\r\n  }\r\n  \r\n  .form-control {\r\n    border-right: 0;\r\n  }\r\n  \r\n  .form-control:focus {\r\n    box-shadow: none;\r\n  }\r\n  \r\n  .btn-primary {\r\n    transition: background-color 0.3s ease;\r\n    float: inline-end;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .input-group {\r\n    position: relative;\r\n  }\r\n  \r\n  .login-form-icon {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: #6c757d;\r\n  }\r\n  \r\n  .input-group input {\r\n    padding-right: 30px;\r\n  }\r\n\r\n  .dabur-logo {\r\n    /* background-color: rgba(255, 255, 255, 0.334); */\r\n    border-radius: 50%;\r\n    height: 100px;\r\n    width: 100px;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .recaptcha-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n}\r\n\r\n.g-recaptcha {\r\n    width: 100% !important;\r\n}\r\n\r\n.g-recaptcha div {\r\n    width: 100% !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
